import { Box, Container, Grid } from "@mui/material"
import { isMobile } from "react-device-detect"
import HeroLogo from "../Hero/HeroLogo"

interface Props {
    children: React.ReactElement
}

const LoginLayout = ({ children }: Props) => {
    return (
        <Container component="main">
            <Grid
                container
                justifyContent={isMobile ? "center" : "start"}
                alignItems="center"
                minHeight={"10vh"}
                pt={4}
            >
                <Grid item md={12} xs={12}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: isMobile ? "center" : "flex-start",
                            justifyContent: "center",
                            textAlign: isMobile ? "center" : "left",
                        }}
                    >
                        <HeroLogo />
                    </Box>
                </Grid>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" minHeight={"90vh"}>
                <Grid item md={4} xs={12}>
                    {children}
                </Grid>
            </Grid>
        </Container>
    )
}
export default LoginLayout
